import axios from "axios";

export const screenConfig = async () => {
  const configFile = "/config.json";
  let conf;
  try {
    console.groupCollapsed("Config file");
    console.log("Config file path: ", configFile);
    const response = await fetch(configFile);
    conf = await response.json();
    console.groupEnd();
  } catch (e) {
    throw Error(`Config: unable to find '${configFile}' file`);
  }
  if (!conf) throw Error("Config is empty");
  return conf;
};

export const postAnalyticEvents = async (mediaId, mediaName) => {
  const conf = await screenConfig();
  const endpoint = `${conf.api}/analytic/submit`;

  const payload = {
    value: {
      type: "event",
      body: [
        {
          site: conf.adsignId,
          device: conf.channelId,
          timestamp: new Date().toISOString(),
          event: {
            id: mediaId,
            name: mediaName,
          },
          action: {
            name: "select",
          },
        },
      ],
    },
  };

  try {
    const response = await axios.post(endpoint, payload);
    console.log("Media analytic posted successfully:", response.data);
  } catch (error) {
    console.error("Failed to post media analytic:", error);
    throw error;
  }
};
